import { render, staticRenderFns } from "./CustomSearch.vue?vue&type=template&id=b2502e20&scoped=true"
import script from "./CustomSearch.vue?vue&type=script&lang=js"
export * from "./CustomSearch.vue?vue&type=script&lang=js"
import style0 from "./CustomSearch.vue?vue&type=style&index=0&id=b2502e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2502e20",
  null
  
)

export default component.exports